export default __webpack_public_path__ + "static/media/13.8ebb0d52.jpg";